var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 22,
    viewBox: "0 0 64 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9755 21.7483L3.97552 21.7483C0.975525 16.2483 -3.22447 4.5483 3.97553 1.74829C12.9755 -1.75171 22.9755 0.951535 31.4755 1.74829C35.9755 1.5346 49.4755 -1.25171 58.9755 1.74829C66.5755 4.14829 62.1422 16.0816 58.9755 21.7483Z",
    fill: "#DE9079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4756 10.7483C19.0492 10.7483 8.97559 14.6166 8.97559 21.7483L53.9756 21.7483C53.9756 14.6166 43.902 10.7483 31.4756 10.7483Z",
    fill: "#D67A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7042 1.38635C55.8489 6.82175 44.7341 9.7482 32.3036 9.7482C19.3917 9.7482 7.17645 6.79005 5.24121 1.29807C11.9155 -0.860327 19.0663 0.123102 25.7033 1.03586C27.6817 1.30796 29.6145 1.57377 31.4754 1.7482C32.4626 1.70133 33.8829 1.53064 35.5991 1.32439C41.3631 0.631693 50.4647 -0.462105 57.7042 1.38635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthL);
export default __webpack_public_path__ + "static/media/Mouth L.0fe712f825fa50742f10cd45eaedf364.svg";
export { ForwardRef as ReactComponent };